export default {
  title: {
    add: 'Add Script',
    update: 'Update Script',
  },
  form: {
    strategy: {
      label: 'Strategy',
      placeholder: 'Select Strategy',
    },
    source: {
      label: 'Source (src)',
      placeholder: 'Enter Source',
    },
    async: {
      label: 'Async',
      placeholder: 'Select Async',
    },
    content: {
      label: 'Content',
      placeholder: 'Enter Content',
    },
  },
  alert: {
    use_case: 'Use case',
  },
  buttons: {
    save: 'Save',
  },
};
